"use strict";
import { __exports as u } from "./index.es515.js";
var s;
function P() {
  return s ? u : (s = 1, (function(f) {
    Object.defineProperty(f, "__esModule", {
      value: !0
    });
    function o(r, e) {
      for (var t in e) Object.defineProperty(r, t, {
        enumerable: !0,
        get: e[t]
      });
    }
    o(f, {
      hasAdjacentParameterIssues: function() {
        return c;
      },
      normalizeAdjacentParameters: function() {
        return p;
      },
      normalizeTokensForRegexp: function() {
        return l;
      },
      stripParameterSeparators: function() {
        return m;
      }
    });
    const a = "_NEXTSEP_";
    function c(r) {
      return typeof r != "string" ? !1 : !!(/\/\(\.{1,3}\):[^/\s]+/.test(r) || /:[a-zA-Z_][a-zA-Z0-9_]*:[a-zA-Z_][a-zA-Z0-9_]*/.test(r));
    }
    function p(r) {
      let e = r;
      return e = e.replace(/(\([^)]*\)):([^/\s]+)/g, `$1${a}:$2`), e = e.replace(/:([^:/\s)]+)(?=:)/g, `:$1${a}`), e;
    }
    function l(r) {
      return r.map((e) => typeof e == "object" && e !== null && // Not all token objects have 'modifier' property (e.g., simple text tokens)
      "modifier" in e && // Only repeating modifiers (* or +) cause the validation error
      // Other modifiers like '?' (optional) are fine
      (e.modifier === "*" || e.modifier === "+") && // Token objects can have different shapes depending on route pattern
      "prefix" in e && "suffix" in e && // Both prefix and suffix must be empty strings
      // This is what causes the validation error in path-to-regexp
      e.prefix === "" && e.suffix === "" ? {
        ...e,
        prefix: "/"
      } : e);
    }
    function m(r) {
      const e = {};
      for (const [t, n] of Object.entries(r))
        typeof n == "string" ? e[t] = n.replace(new RegExp(`^${a}`), "") : Array.isArray(n) ? e[t] = n.map((i) => typeof i == "string" ? i.replace(new RegExp(`^${a}`), "") : i) : e[t] = n;
      return e;
    }
  })(u), u);
}
export {
  P as __require
};
//# sourceMappingURL=index.es491.js.map
